import { Component, Input, OnInit } from "@angular/core";
import { ServiceItem } from "src/app/model/model";

@Component({
  selector: "app-service-item-card",
  templateUrl: "./service-item-card.component.html",
  styleUrls: ["./service-item-card.component.css"]
})
export class ServiceItemCardComponent implements OnInit {

  constructor() { }

  @Input()
  serviceItem: ServiceItem;

  ngOnInit(): void {
  }

}
